/* @flow */

import slugify from 'slugify';
import { toString } from 'lodash/fp';

function decodeCompetiton(comp: Object = {}) {
  return {
    id: toString(comp.id),
    name: comp.short_name,
    slug: slugify(comp.short_name, { lower: true })
  };
}

function decodeSport(sport: Object = {}) {
  return {
    id: sport.id,
    icon: sport.icon,
    name: sport.name,
    subcategories: sport.competition_types.map(decodeCompetiton),
    slug: slugify(sport.name, { lower: true })
  };
}

export default decodeSport;
